/* Copyright (c) 2026 Xperi. All Rights Reserved. */

export { buildClaimJwt, buildPrimaryCredentialJwt } from "./claimJwtBuilder";
export { canNavigateBackInHistory } from "./canNavigateBackInHistory";
export { clearAppStorage } from "./clearAppStorage";
export {
  attemptSilentChunkReload,
  canAttemptSilentChunkReload,
  getChunkLoadErrorSignature,
  installChunkLoadRecovery,
  isChunkLoadError
} from "./chunkLoadRecovery";
export {
  canAttemptSilentReload,
  recordSilentReloadAttempt,
  SILENT_RELOAD_COOLDOWN_MS,
  SILENT_RELOAD_STORAGE_KEY
} from "./silentReloadGuard";
export {
  canAttemptRestart,
  recordRestartAttempt,
  SILENT_RESTART_LIMIT,
  SILENT_RESTART_RESET_DELAY_MS,
  SILENT_RESTART_STORAGE_KEY
} from "./restartLimitGuard";
export { reloadApplicationAtRoot } from "./reloadApplicationAtRoot";
export { DimensionScaler } from "./DimensionScaler";
export { formatAiringClockTime } from "./formatAiringClockTime";
export {
  APP_VERSION_QUERY_PARAM,
  getAppVersionFromUrl,
  isValidAppVersion
} from "./getAppVersionFromUrl";
export { getOSVersion } from "./getOSVersion";
export { isFreshInstallLaunch } from "./isFreshInstallLaunch";
export { buildPosterImageUrl, IMAGE_TYPE_API_MAP } from "./posterImage";
export { removeFreshInstallFromUrl } from "./removeFreshInstallFromUrl";
export {
  APP_VERSION_COOKIE_MAX_AGE_SECONDS,
  APP_VERSION_COOKIE_NAME,
  clearAppVersionCookie,
  setAppVersionCookie
} from "./setAppVersionCookie";
export type { TImageType } from "./posterImage";
export { boundedSet, boundedPush } from "./BoundedCollectionUtils";
export {
  extractServiceErrorBodyMessage,
  extractServiceErrorCode,
  extractServiceErrorMessage,
  localizedErrorFallback
} from "./errorMessage";
export { formatRetryErrorMessage } from "./retryErrorFormatter";
export {
  getHttpStatus,
  HTTP_STATUS_UNAUTHORIZED,
  isUnauthorizedError
} from "./httpStatus";
export { scrollIntoView } from "./scrollIntoView";
export type { IScrollIntoViewOptions, TScrollBlock } from "./scrollIntoView";
export { scrollByWheel } from "./scrollByWheel";
export type { IWheelDelta } from "./scrollByWheel";
